<template>
  <section>
    <div class="row top-margin">
      <div class="col-md-6">
        <div class="form-group">
          <label for="address">First name <strong class="text-info">*</strong></label>
          <input type="text" name="FirstName" id="FirstName" v-model="firstName" placeholder="First name" :class="{ 'form-control': true, 'form-control-error': errors.has('FirstName') }" v-validate="{required: true}" />
          <span v-if="errors.has('FirstName')" class="error-feedback">Required</span>
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group">
          <label for="address">Last name <strong class="text-info">*</strong></label>
          <input type="text" name="LastName" id="LastName" v-model="lastName" placeholder="Last name" :class="{ 'form-control': true, 'form-control-error': errors.has('LastName') }" v-validate="{required: true}" />
          <span v-if="errors.has('LastName')" class="error-feedback">Required</span>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-6">
        <label for="date-time-input">Date of birth <strong v-if="!looseValidation" class="text-info">*</strong></label>
        <div class="form-group input-group date birth-field-bottom">
          <date-picker placeholder="mm/dd/yyyy" v-model="dateOfBirth" id="date-time-input" name="date-time-input" :wrap="true" :config="dateBirthConfig" :class="{ 'form-control': true, 'form-control-error': !looseValidation && isBirthFieldInvalid }" v-validate="{required: !looseValidation}"
            @blur.native="checkDateBirth(dateOfBirth)">
          </date-picker>
          <div class="input-group-addon">
            <span class="fa fa-calendar"></span>
          </div>
        </div>
        <span v-if="!looseValidation && isBirthFieldInvalid" class="error-feedback">Required</span>
        <span v-if="!looseValidation && !this.isDateBirthValid(dateOfBirth)" class="error-feedback">You must be 18 years or older in order to invest with us.</span>
      </div>

      <div class="col-md-6">
        <div class="form-group">
          <label for="ssn">Social security number <strong class="text-info" v-if="!looseValidation">*</strong></label>
          <div class="availability-check-container">
            <input
              type="text"
              name="ssn"
              id="ssn"
              v-model="socialSecurityNum"
              placeholder="000-00-0000"
              onfocus="this.value=''"
              v-on:click="socialSecurityNum=''"
              :class="{ 'form-control': true, 'form-control-error': errors.has('ssn') }"
              v-validate="{required: !looseValidation, regex: /(^[0-9]{3}\-[0-9]{2}\-[0-9]{4}$)|(x{3}\-x{2}(\-[0-9]{4})?)/}"
              v-mask="'***-**-9999'"
              @input="ssnInput"
              @blur="checkSsnAvailability"
            />
            <div class="availability-indicator" v-if="ssnAvailabilityStatus !== null">
              <span v-if="ssnAvailabilityStatus === 'checking'" class="fa fa-spinner fa-spin text-info"></span>
              <span v-if="ssnAvailabilityStatus === 'available'" class="fa fa-check text-success"></span>
              <span v-if="ssnAvailabilityStatus === 'unavailable'" class="fa fa-times text-danger"></span>
            </div>
          </div>
          <span v-if="errors.has('ssn')" class="error-feedback">{{ errors.first('ssn') }}</span>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-6">
        <div class="form-group">
          <label for="address">Primary email<strong class="text-info" v-if="emailRequired">*</strong></label>
          <div class="availability-check-container">
            <input
              type="text"
              name="PrimaryEmail"
              id="PrimaryEmail"
              v-model="email"
              placeholder="Primary email"
              :class="{ 'form-control': true, 'form-control-error': errors.has('PrimaryEmail') }"
              @input="emailUpdated"
              @blur="checkEmailAvailability"
            />
            <div class="availability-indicator" v-if="emailAvailabilityStatus !== null">
              <span v-if="emailAvailabilityStatus === 'checking'" class="fa fa-spinner fa-spin text-info"></span>
              <span v-if="emailAvailabilityStatus === 'available'" class="fa fa-check text-success"></span>
              <span v-if="emailAvailabilityStatus === 'unavailable'" class="fa fa-times text-danger"></span>
            </div>
          </div>
          <span v-if="errors.has('PrimaryEmail')" class="error-feedback">{{ errors.first('PrimaryEmail') }}</span>
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group">
          <label for="address">Secondary email</label>
          <input type="text" name="SecondaryEmail" id="SecondaryEmail" v-model="secondaryEmail" placeholder="Secondary Email" :class="{ 'form-control': true, 'form-control-error': errors.has('SecondaryEmail') }" />
          <span v-if="errors.has('SecondaryEmail')" class="error-feedback">{{ errors.first('SecondaryEmail') }}</span>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-6">
        <div class="form-group">
          <label for="primaryPhoneNum">Primary phone number <strong class="text-info">*</strong></label>
          <input
            id="primaryPhoneNum"
            name="primaryPhoneNum"
            v-model="primaryPhoneNum"
            placeholder="Phone number"
            :class="{ 'form-control': true, 'form-control-error': errors.has('primaryPhoneNum') }"
            v-validate="{ required: true, regex: /(^\([0-9]{3}\) [0-9]{3}-[0-9]{4}$)|([0-9]{10})/ }"
            v-mask="'(999) 999-9999'"
            @input="onPhoneNumberChange"
          />
          <span v-if="errors.has('primaryPhoneNum')" class="error-feedback">Required</span>
        </div>
      </div>

      <div class="col-md-6">
        <div class="form-group">
          <label for="secondaryPhoneNum">Secondary phone number</label>
          <input id="secondaryPhoneNum" v-model="secondaryPhoneNum" name="secondaryPhoneNum" class="form-control" type="text"  :class="{ 'form-control': true, 'form-control-error': errors.has('secondaryPhoneNum') }" v-validate="{ regex:/(^\([0-9]{3}\) [0-9]{3}-[0-9]{4}$)|([0-9]{10})/ }" v-mask="'(999) 999-9999'" @input="onPhoneNumberChange" />
            <span v-if="errors.has('secondaryPhoneNum')" class="error-feedback">Wrong phone number</span>
        </div>
      </div>
    </div>

    <div v-if="enableMfa" class="row top-margin">
      <div class="col-md-12">
        <div class="form-group">
          <label for="mfaPhonePreference">
            <strong>MFA Phone Preference</strong>
          </label>
          <select
            id="mfaPhonePreference"
            v-model="mfaPhonePreference"
            class="form-control"
          >
            <option :value="null">-- Select --</option>
            <option value="PRIMARY" :disabled="!hasPrimaryPhone">
              Primary Phone
            </option>
            <option value="SECONDARY" :disabled="!hasSecondaryPhone">
              Secondary Phone
            </option>
            <option value="NONE">None (Email only)</option>
          </select>
          <small class="form-text text-muted">
            Select which phone number should be used for SMS multi-factor authentication.
          </small>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
  import moment from 'moment';
  import { mapActions } from 'vuex';

  import {
    formatDate,
  } from '@/util';

  const mix = {
    methods: {
      formatDate,
    },
  };

  export default {
    name: 'BasicInformation',
    mixins: [mix],
    props: {
      basicInformation: {
        type: Object,
        required: true,
        default: {},
      },
      looseValidation: {
        type: Boolean,
        required: false,
        default: false,
      },
      enableMfa: {
        type: Boolean,
        required: false,
        default: false,
      },
    },
    data() {
      return {
        minimumAge: 18,
        isBirthFieldInvalid: false,
        dateBirthConfig: {
          format: 'MM/DD/YYYY',
        },
        dateBirthFormat: 'YYYY-MM-DD',
        previousSSN: '',
        email: '',
        secondaryEmail: '',
        firstName: '',
        lastName: '',
        socialSecurityNum: '',
        primaryPhoneNum: '',
        secondaryPhoneNum: '',
        mfaPhonePreference: null,
        dateOfBirth: '',
        userType: '',
        ssnAvailabilityStatus: null,
        emailAvailabilityStatus: null,
      };
    },
    watch: {
      basicInformation: function basicInformationUpdated(basicInformation) {
        this.email = basicInformation.email;
        this.secondaryEmail = basicInformation.secondaryEmail;
        this.firstName = basicInformation.firstName;
        this.lastName = basicInformation.lastName;
        if (basicInformation.socialSecurityNum) {
          this.socialSecurityNum = `xxx-xx-${basicInformation.socialSecurityNum}`;
        }
        this.primaryPhoneNum = basicInformation.primaryPhoneNum;
        this.secondaryPhoneNum = basicInformation.secondaryPhoneNum;
        this.mfaPhonePreference = basicInformation.mfaPhonePreference || null;
        this.userType = basicInformation.userType;
        this.dateOfBirth = moment.utc(`${basicInformation.dateOfBirth} 12:00:00`);
        // Reset availability status when data changes
        this.emailAvailabilityStatus = null;
        this.ssnAvailabilityStatus = null;
        this.emailUpdated();
      },
    },
    computed: {
      emailRequired() {
        return this.userType === 'INSTITUTIONAL_REPRESENTATIVE' || this.userType === 'READ_ONLY';
      },
      hasPrimaryPhone() {
        return !!this.getPhoneDigits(this.primaryPhoneNum);
      },
      hasSecondaryPhone() {
        return !!this.getPhoneDigits(this.secondaryPhoneNum);
      },
      canSetPreference() {
        return this.hasPrimaryPhone || this.hasSecondaryPhone;
      },
    },
    methods: {
      ...mapActions('userCreationByAdmin', [
        'checkAvailability',
      ]),
      validate() {
        const primaryEmailValid = this.email === null || this.email.trim() === '' || this.validEmail(this.email);
        const secondaryEmailValid = this.secondaryEmail === null || this.secondaryEmail.trim() === '' || this.validEmail(this.secondaryEmail);
        if (this.looseValidation) {
          return primaryEmailValid &&
               secondaryEmailValid &&
               this.firstName.trim() !== '' &&
               this.lastName.trim() !== '' &&
               this.primaryPhoneNum.trim() !== '' &&
               !this.errors.has('primaryPhoneNum') &&
               !this.errors.has('secondaryPhoneNum') &&
               !this.errors.has('ssn') &&
               !this.errors.has('PrimaryEmail');
        }
        return primaryEmailValid &&
               secondaryEmailValid &&
               this.firstName.trim() !== '' &&
               this.lastName.trim() !== '' &&
               this.primaryPhoneNum.trim() !== '' &&
               this.socialSecurityNum.trim() !== '' &&
               !this.isBirthFieldInvalid &&
               !this.errors.has('primaryPhoneNum') &&
               !this.errors.has('secondaryPhoneNum') &&
               !this.errors.has('ssn') &&
               !this.errors.has('PrimaryEmail');
      },
      checkDateBirth(dateOfBirth) {
        if (dateOfBirth === '' || dateOfBirth === null) {
          this.isBirthFieldInvalid = true;
        } else {
          this.isBirthFieldInvalid = false;
        }
      },
      isDateBirthValid(dateOfBirth) {
        if (dateOfBirth === '') {
          return false;
        }
        if (this.basicInformation.userType !== 'INVESTOR') {
          return true;
        }
        const birthYear = new Date(dateOfBirth).getFullYear();
        const currentYear = new Date().getFullYear();
        return (currentYear - birthYear) >= this.minimumAge;
      },
      isSsnUpdated() {
        const ssn = this.getSsnDigits(this.socialSecurityNum);
        return !ssn.includes('x');
      },
      validEmail(email) {
        const regex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/; // eslint-disable-line no-useless-escape
        return regex.test(email);
      },
      getSsnDigits(ssn) {
        if (ssn.includes('x')) {
          return undefined;
        }
        return ssn.replace(/[- ]/g, '');
      },
      getPhoneDigits(phoneNum) {
        return phoneNum ? phoneNum.replace(/[-() ]/g, '') : '';
      },
      getDateOnlyDOB(date) {
        if (moment.isMoment(date)) {
          return date.isValid() ? date.format(this.dateBirthFormat).toString() : null;
        }

        return date === null || date === '' ? null : moment(date).format(this.dateBirthFormat).toString();
      },
      emailUpdated() {
        const valid = this.validEmail(this.email);
        // Clear email errors and availability status when user types
        this.$validator.errors.remove('PrimaryEmail');
        this.emailAvailabilityStatus = null; // Reset availability status on input
        this.$emit('emailUpdated', { valid });
      },
      ssnInput() {
        // Clear SSN errors and availability status when user types
        this.$validator.errors.remove('ssn');
        this.ssnAvailabilityStatus = null;
      },
      onPhoneNumberChange() {
        // Auto-clear preference if the selected phone is removed
        if (this.mfaPhonePreference === 'PRIMARY' && !this.hasPrimaryPhone) {
          this.mfaPhonePreference = null;
        }
        if (this.mfaPhonePreference === 'SECONDARY' && !this.hasSecondaryPhone) {
          this.mfaPhonePreference = null;
        }
      },
      getData() {
        return {
          email: this.email,
          secondaryEmail: this.secondaryEmail,
          firstName: this.firstName,
          lastName: this.lastName,
          socialSecurityNum: this.getSsnDigits(this.socialSecurityNum),
          primaryPhoneNum: this.getPhoneDigits(this.primaryPhoneNum),
          secondaryPhoneNum: this.getPhoneDigits(this.secondaryPhoneNum),
          mfaPhonePreference: this.mfaPhonePreference,
          dateOfBirth: this.getDateOnlyDOB(this.dateOfBirth),
          userType: this.basicInformation.userType,
        };
      },
      async checkSsnAvailability() {
        // Clear any previous SSN errors first
        this.$validator.errors.remove('ssn');

        // Don't check if there are validation errors
        if (this.errors.has('ssn') || !this.socialSecurityNum || this.socialSecurityNum.trim() === '') {
          this.ssnAvailabilityStatus = null;
          return;
        }

        // Don't check if the SSN is the masked version (contains 'x')
        const ssnDigits = this.getSsnDigits(this.socialSecurityNum);
        if (!ssnDigits || ssnDigits.includes('x')) {
          this.ssnAvailabilityStatus = null;
          return;
        }

        // If this is the same SSN as the original user has, don't check availability
        if (this.basicInformation && this.basicInformation.socialSecurityNum &&
            ssnDigits === this.basicInformation.socialSecurityNum) {
          this.ssnAvailabilityStatus = null;
          return;
        }

        this.ssnAvailabilityStatus = 'checking';

        try {
          const response = await this.checkAvailability({ ssn: ssnDigits });
          this.ssnAvailabilityStatus = response ? 'available' : 'unavailable';

          // If SSN is not available, add validation error
          if (!response) {
            this.$validator.errors.add({
              field: 'ssn',
              msg: 'The social security number that was entered is not accepted.',
              id: 'ssn_error',
            });
          }
        } catch (error) {
          console.error('Error checking SSN availability:', error);
          this.ssnAvailabilityStatus = null;

          // Check if this is an SSN-specific error from the API
          if (error && error.message && error.message.includes('social security number')) {
            this.ssnAvailabilityStatus = 'unavailable';
            this.$validator.errors.add({
              field: 'ssn',
              msg: 'The social security number that was entered is not accepted.',
              id: 'ssn_error',
            });
          }
        }
      },
      async checkEmailAvailability() {
        // Clear any previous email errors first
        this.$validator.errors.remove('PrimaryEmail');

        // Don't check if there are validation errors or email is empty
        if (this.errors.has('PrimaryEmail') || !this.email || this.email.trim() === '' || !this.validEmail(this.email)) {
          this.emailAvailabilityStatus = null;
          return;
        }

        // If this is the same email as the original user has, don't check availability
        if (this.basicInformation && this.basicInformation.email &&
            this.email.toLowerCase() === this.basicInformation.email.toLowerCase()) {
          this.emailAvailabilityStatus = null;
          return;
        }

        this.emailAvailabilityStatus = 'checking';

        try {
          const response = await this.checkAvailability({ email: this.email.toLowerCase() });
          this.emailAvailabilityStatus = response ? 'available' : 'unavailable';

          // If email is not available, add validation error
          if (!response) {
            this.$validator.errors.add({
              field: 'PrimaryEmail',
              msg: 'An account with the given email already exists',
              id: 'email_error',
            });
          }
        } catch (error) {
          console.error('Error checking email availability:', error);
          this.emailAvailabilityStatus = null;

          // Check if this is an email-specific error from the API
          if (error && error.message && (error.message.includes('email') || error.message.includes('Email'))) {
            this.emailAvailabilityStatus = 'unavailable';
            this.$validator.errors.add({
              field: 'PrimaryEmail',
              msg: 'An account with the given email already exists',
              id: 'email_error',
            });
          }
        }
      },
    },
  };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .message-feedback {
    background-color: #dbe9db;
    margin-left: 2%;
    margin-top: 2%;
    margin-bottom: 2%;
    width: 66%;
  }

  .birth-field-bottom {
    margin-bottom: 5px;
  }

  .button-submit {
    background-color: #127285;
  }

  .date-pick-style {
    width: 90%;
  }

  .content-wrapper {
    border-top: none;
  }

  .warning-heading {
    background-color: #f9f2ce !important;
    padding: 10px;
    margin: 0 auto 20px;
    font-size: 14px;
    font-weight: 500;
  }

  .alert-warning {
    background-color: #fcf8e3;
    border-color: #faf2cc;
    color: #8a6d3b;
    margin: 25px;
    margin-bottom: 10px;
  }

  .btn-back {
    color: #31b0d5;
    background-color: Transparent;
    background-repeat: no-repeat;
    border: none;
    cursor: pointer;
    overflow: hidden;
    outline: none;
    padding-left: 20px;
  }

  .icon-back {
    position: relative;
  }

  .icon-back:before {
    content: "\f060";
    font-family: FontAwesome;
    position: absolute;
    left: 0px;
  }

  .alert-warning .alert-link {
    color: #66512c;
  }

  .line-separator {
    padding: 8px;
    line-height: 1.52857143;
    vertical-align: top;
    border-top: 1px solid #eee;
  }

  .left-margin {
    margin-left: 4%;
  }

  .right-margin {
    margin-right: 4%;
  }

  .top-margin {
    margin-top: 2%;
  }

  .bottom-margin {
    margin-bottom: 2%;
  }

  .space {
    margin-top: 4%;
  }

  .content-heading {
    font-weight: normal;
  }

  .upload-container {
    height: 80px;
    padding-top: 10px;
  }

  .panel-title {
    font-size: 20px;
  }

  .panel-subtitle {
    font-size: 16px;
  }

  .panel-default {
    padding: 30px 40px;
    width: 900px;
  }

  .panel-heading {
    background-color: #ffffff;
    font-size: 16px;
    padding: 0px 5px;
  }

  label {
    color: #888;
    font-size: 14px;
    width: 300px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    margin-bottom: 0px;
  }

  select:required:invalid {
    color: lightgray;
  }

  option[value=""][disabled] {
    display: none;
  }

  option {
    color: black;
  }

   ::placeholder {
    /* Chrome, Firefox, Opera, Safari 10.1+ */
    color: lightgray;
    opacity: 1;
    /* Firefox */
  }

   :-ms-input-placeholder {
    /* Internet Explorer 10-11 */
    color: lightgray;
  }

   ::-ms-input-placeholder {
    /* Microsoft Edge */
    color: lightgray;
  }

  .disabled-state {
    color: #ccc;
  }

  .text-red {
    color: #a94442;
  }

  .btn-new {
    background-color: #127285;
  }

  .radio-item {
    display: inline-block;
    position: relative;
    padding: 0 6px;
  }

  .radio-item input[type='radio'] {
    display: none;
  }

  .radio-item label {
    color: #666;
    font-weight: normal;
  }

  .radio-item label:before {
    content: " ";
    display: inline-block;
    position: relative;
    top: 5px;
    left: 0px;
    margin: 0 5px 0 0;
    width: 20px;
    height: 20px;
    border-radius: 11px;
    background-color: transparent;
  }

  .radio-item-repay label:before {
    left: 190px;
  }

  .radio-item-unselected label:before {
    border: 2px solid #d3d3d3;
  }

  .radio-item input[type=radio]:checked+label:after {
    border-radius: 11px;
    width: 10px;
    height: 10px;
    position: absolute;
    top: 10px;
    left: 11px;
    content: " ";
    display: block;
  }

  .radio-item-repay input[type=radio]:checked+label:after {
    left: 201px;
  }
  .table {
    width: 1400px;
  }

  .table > thead > tr > th {
    vertical-align: bottom;
    border-bottom: 0px #ddd;
  }
  tbody{
    height:200px;
      overflow-y:auto;
      width: 100%;
  }
  thead{
    display:block;
    width: 100%;
  }
  tbody{
    display:block;
  }
  tr{
    width: 100%;
    display: block;
  }
  td{
    display:block;
    width: 14%;
  }
  th{
    display:block;
    width: 14%;
  }
  td{
    float: left;
    width: 14%;
  }
  thead{
    float: left;
  }
  tr{
    float: left;
  }
  th{
    float: left;
  }
  .smallWidth{
    width: 10%
  }
  .bigWidth{
    width: 16%
  }

  .availability-check-container {
    position: relative;
  }

  .availability-indicator {
    position: absolute;
    right: 10px;
    top: 50%;
    transform: translateY(-50%);
    z-index: 10;
    font-size: 16px;
  }

  .text-success {
    color: #28a745 !important;
  }

  .text-danger {
    color: #dc3545 !important;
  }

  .text-info {
    color: #17a2b8 !important;
  }
</style>



// WEBPACK FOOTER //
// BasicInformation.vue?16ba186f